const shopTheLookSelectors = {
  trigger: '[data-shop-the-look-trigger]',
  content: '[data-shop-the-look-content]',
};

function openShopTheLookDrawer(triggeredBy) {
  const drawer = document.querySelector('product-set-drawer');
  const template = document.querySelector(shopTheLookSelectors.content);
  if (!drawer || !template) return;

  drawer.openWithTitle(drawer.dataset.shopTheLookTitle, triggeredBy);
  drawer.renderContent(template.innerHTML);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(shopTheLookSelectors.trigger).forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openShopTheLookDrawer(trigger);
    });
  });
});
